module.exports = __webpack_public_path__ + "img/home-active.28b027ab.png";